export default __webpack_public_path__ + "static/media/or-1.0a889b47.jpg";